import * as yup from "yup";

export const adicionarCustoGPSchema = yup.object({
  idDescricao: yup
    .number()
    .typeError("O custo é obrigatório")
    .required("O custo é obrigatório")
    .moreThan(0, "O custo é obrigatório"),
  valor: yup
    .string()
    .required("O valor é obrigatório")
    .test("valor", "O valor é obrigatório", (v) => !["", "0.00"].includes(v ?? "")),
  observacao: yup.string().nullable().default(""),
});
